import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { Entrevista } from '@app/models/entrevista.model';
import { EntrevistaService } from '@app/services/entrevista.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-entrevista-lista',
  templateUrl: './entrevista-lista.component.html'
})

export class EntrevistaListaComponent implements OnInit {

  lstEntrevista: Entrevista[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = '';
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private entrevistaService: EntrevistaService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.entrevistaService.obterPesquisa(descricao, pagina)
      .subscribe(data => {
        this.lstEntrevista = data.Dados,
          this.paginacao.totalDeItens = data.Total
      }, erro => {
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(entrevista: Entrevista) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja mesmo excluir a entrevista: ' + entrevista.Id + ' - ' + entrevista.Descricao + '?';
    this.bsModalRef.content.confirmar = () => {
      this.entrevistaService.deletar(entrevista.Id).subscribe(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  limparStorage() {
    if (window.sessionStorage.getItem('entrevista')) {
      window.sessionStorage.removeItem('entrevista');
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
